import flowRight from 'lodash/flowRight';
import pako from 'pako';

function convertUint8ArrayToBinaryString(u8Array: Uint8Array): string {
  let i, len = u8Array.length, b_str = "";
  for (i=0; i<len; i++) {
    b_str += String.fromCharCode(u8Array[i]);
  }
  return b_str;
}

function convertBinaryStringToUint8Array(bStr: string): Uint8Array {
  let i, len = bStr.length, u8_array = new Uint8Array(len);
  for (i = 0; i < len; i++) {
    u8_array[i] = bStr.charCodeAt(i);
  }
  return u8_array;
}

export default function useShareService() {
  const encode = (builder) => {
    if(builder.modelData.surffaceList.length === 0) {
      return flowRight(btoa, convertUint8ArrayToBinaryString, pako.deflate, JSON.stringify)({
        version: 1,
        modelType: 'Default',
        manifest: builder?.manifestURL,
        modelData: {
          pattern: builder?.modelData?.pattern,
          collar: builder?.modelData?.collar,
          colorList: [...builder?.modelData?.colorList?.entries() ?? []].map(([id, color]) => ({color, id})),
        },
        imagesData: {
          ...(builder?.imagesData?.sponsorImages && {sponsorImages: builder?.imagesData?.sponsorImages}),
          ...(builder?.imagesData?.teamImage?.public_url && {teamImage: builder?.imagesData?.teamImage}),
          ...(
              (builder?.imagesData?.sponsorFlag?.left?.id || builder?.imagesData?.sponsorFlag?.right?.id) &&
              {sponsorFlag: builder?.imagesData?.sponsorFlag}
          )
        },
        membersData: {
          members: builder?.membersData?.members.map(data => ({...data})),
          memberTextColors: builder?.membersData?.memberTextColors,
          memberFontFamily: builder?.membersData?.memberFontFamily,
          membersFontSize: builder?.membersData?.membersFontSize
        }
      });
    }else{
      return flowRight(btoa, convertUint8ArrayToBinaryString, pako.deflate, JSON.stringify)({
        version: 1,
        modelType: '3dMouseMat',
        manifest: builder?.manifestURL,
        modelData: {
          pattern: builder?.modelData?.pattern,
          collar: builder?.modelData?.collar,
          colorList: [...builder?.modelData?.colorList?.entries() ?? []].map(([id, color]) => ({color, id})),
          surfface: builder?.modelData?.surfface,
        },
        imagesData: {
          ...(builder?.imagesData?.sponsorImages && {sponsorImages: builder?.imagesData?.sponsorImages}),
          ...(builder?.imagesData?.teamImage?.public_url && {teamImage: builder?.imagesData?.teamImage}),
          ...(
              (builder?.imagesData?.sponsorFlag?.left?.id || builder?.imagesData?.sponsorFlag?.right?.id) &&
              {sponsorFlag: builder?.imagesData?.sponsorFlag}
          ),
          ...(builder?.imagesData?.image && {image: builder?.imagesData?.image}),
          ...(builder?.imagesData?.mouseSurface && {surface: builder?.imagesData?.mouseSurface}),
        },
        membersData: {
          members: builder?.membersData?.members.map(data => ({...data})),
          memberTextColors: builder?.membersData?.memberTextColors,
          memberFontFamily: builder?.membersData?.memberFontFamily,
          membersFontSize: builder?.membersData?.membersFontSize
        }
      });
    }
  };

  const decode = (shareData) => {
    try {
      return flowRight(JSON.parse, convertUint8ArrayToBinaryString, pako.inflate, convertBinaryStringToUint8Array, atob)(shareData);
    } catch (e) {
      return {};
    }
  };


  return {
    encode,
    decode
  };
}
